"use strict";

module.exports = {
  'name': 'acosh',
  'category': 'Trigonometry',
  'syntax': ['acosh(x)'],
  'description': 'Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.',
  'examples': ['acosh(1.5)'],
  'seealso': ['cosh', 'asinh', 'atanh']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/trigonometry/acosh.js
// module id = 954
// module chunks = 0